import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useSiteContent } from "@/lib/siteContent";

const navCls = ({ isActive }) =>
  `text-xs tracking-[0.2em] uppercase transition-colors ${
    isActive ? "text-[#CFA05E]" : "text-[#A39E93] hover:text-[#FDFBF7]"
  }`;

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const site = useSiteContent();

  return (
    <div className="min-h-screen flex flex-col bg-[#120D0C] text-[#FDFBF7]">
      <header className="sticky top-0 z-40 backdrop-blur-2xl bg-[#120D0C]/70 border-b border-[#362B28]/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
          <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
            <span className="font-display text-2xl tracking-tight">Park <span className="text-[#CFA05E]">Collections</span></span>
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            <NavLink to="/" end className={navCls} data-testid="nav-home">Atelier</NavLink>
            <NavLink to="/designer" className={navCls} data-testid="nav-designer">Designer</NavLink>
            {user && <NavLink to="/designs" className={navCls} data-testid="nav-my-designs">My Designs</NavLink>}
            {user?.role === "admin" && (
              <NavLink to="/admin" className={navCls} data-testid="nav-admin">Admin</NavLink>
            )}
          </nav>
          <div className="flex items-center gap-4">
            {user ? (
              <>
                <span className="hidden sm:inline text-xs text-[#A39E93] tracking-wide" data-testid="user-name">
                  {user.name}
                </span>
                <button
                  onClick={() => { logout(); navigate("/"); }}
                  data-testid="logout-button"
                  className="text-xs tracking-[0.2em] uppercase text-[#A39E93] hover:text-[#CFA05E] transition"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/auth"
                data-testid="login-cta"
                className="text-xs tracking-[0.2em] uppercase text-[#CFA05E] hover:text-[#E6B875] transition"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-[#362B28]/60 mt-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-3 gap-10">
          <div>
            <div className="font-display text-2xl">Park <span className="text-[#CFA05E]">Collections</span></div>
            <p className="text-sm text-[#A39E93] mt-3 max-w-xs leading-relaxed">
              {site.tagline}
            </p>
          </div>
          <div className="text-xs tracking-[0.2em] uppercase text-[#A39E93] space-y-2">
            <div className="text-[#FDFBF7]">Atelier</div>
            <div>{site.atelier_address}</div>
            <div>{site.atelier_hours}</div>
          </div>
          <div className="text-xs tracking-[0.2em] uppercase text-[#A39E93] space-y-2">
            <div className="text-[#FDFBF7]">Contact</div>
            <div data-testid="footer-email">{site.contact_email}</div>
            <div data-testid="footer-phone">{site.contact_phone}</div>
            {site.instagram && <div>Instagram · {site.instagram}</div>}
            {site.whatsapp && <div>WhatsApp · {site.whatsapp}</div>}
          </div>
        </div>
        <div className="border-t border-[#362B28]/60 py-6 text-center text-xs text-[#A39E93] tracking-wider">
          © {new Date().getFullYear()} Park Collections — Crafted in India.
        </div>
      </footer>
    </div>
  );
}
